// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Requisition: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 52"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M52.3 13.2l-4-4c-.8-.8-2.3-.8-3.1 0L42.4 12v.1L30.9 23.6c-.2.2-.3.3-.3.5l-2.4 7.4c-.2.5 0 1 .3 1.4.3.3.6.4 1 .4.1 0 .3 0 .4-.1l7.6-2.3.6-.3L49.6 19v-.1l2.8-2.8c.3-.2.5-.8.5-1.4 0-.6-.2-1.1-.6-1.5zm-16 15.3l-4.7 1.4 1.5-4.6 10.4-10.4 3.2 3.2-10.4 10.4zm12.2-12.3L45.3 13l1.4-1.4 3.2 3.2-1.4 1.4zm-16.1 1c0-.8-.6-1.4-1.4-1.4H10.9c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4H31c.8 0 1.4-.6 1.4-1.4zM26.8 26c0-.8-.6-1.4-1.4-1.4H10.9c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h14.6c.7 0 1.3-.6 1.3-1.4zm-15.9 7.4c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4H22c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4H10.9z"/><path d="M38.8 33.5c-.8 0-1.4.6-1.4 1.4v13.6c0 .1-.1.2-.2.2H4.7c-.1 0-.2-.1-.2-.2v-45c0-.1.1-.2.2-.2h32.5c.1 0 .2.1.2.2v6.7c0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4V3.5c0-1.6-1.3-2.9-2.9-2.9H4.7C3.1.6 1.8 1.9 1.8 3.5v44.9c0 1.6 1.3 2.9 2.9 2.9h32.5c1.6 0 2.9-1.3 2.9-2.9V34.8c0-.7-.6-1.3-1.3-1.3z"/></svg>;
};

export default React.memo(Requisition);
